import "./ForgotPassword.css";
import React from "react";
import { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { apiRequest } from "services/apiRequest";
import { requestType } from "services/requests";
import { Formik, Form, Field } from "formik";
import { forgotPasswordSchema } from "./ForgotPasswordValidation";

import BrandingImage from "assets/images/Group 48.png";
import ExpressionPink from "assets/images/expression-pink4.png";
import ExpressionGreen from "assets/images/expression-green2.png";
import ApproveIcon from "assets/images/Approve.png";
import SuccessIcon from "assets/images/register-success-icon.png";
import Swal from 'sweetalert2'
import Loader from "utilities/reusableComponent/Loader/Loader";

function ForgotPassword() {
  const navigate = useNavigate();
  const {userToken} = useSelector((state) => state.auth)
  const [loading, setLoading] = useState(false);

  // Login form initial values
  const initialValues = {
    email: ""
  }

  // Handling on Submit register form
  const onHandleResetPassword = async(values) => {
    setLoading(true);
    const payload = {
      "email": values.email
    };

    // Submit request forgot pasword data to API
    const res = await apiRequest({
        requestType: requestType.forgotPassword,
        payload: {
            data: payload
        },
    });

    if(res?.data?.status === 0) {
        // show success popup message when reset request is success
        const swalSuccessMessage = Swal.mixin({
            customClass: {
                popup: 'swal-success-popup',
                confirmButton: "swal-success",
                title: 'swal-title',
            },
            buttonsStyling: false,
            iconsStyling: false
        });
        swalSuccessMessage.fire({
            title: "Success!",
            html: "<p class='swal-text-html'>We have sent an email to reset your password. Please follow the link in your inbox to reset your password.</p>",
            imageUrl: SuccessIcon,
            imageWidth: 65,
            imageHeight: 60,
            confirmButtonText: "Login",
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                navigate("/login");
            }
        });
        setLoading(false);
    } else {
        // show error message when login is failed
        const swalFailedMessage = Swal.mixin({
            customClass: {
                popup: 'swal-failed-popup',
                confirmButton: "swal-success",
                title: 'swal-title',
            },
            buttonsStyling: false,
        });
        swalFailedMessage.fire({
            title: "Failed!",
            html: `<p class='swal-text-html'>${res.data.error_message}</p>`,
            imageWidth: 65,
            imageHeight: 60,
            confirmButtonText: "Ok",
        });
        setLoading(false);
    }
  }

  useEffect(() => {
    // if user has login redirect to homepage
    if (userToken) {
      navigate("/home");
    }
  }, []);

  return (
    <Fragment>
      <div className="login mx-auto relative flex">
        <aside className="w-[473px] flex-shrink-0 max-h-screen bg-yellow sticky right-0 top-0 h-screen overflow-hidden">
          <img
            src={BrandingImage}
            alt=""
            className="w-[199px] mt-[277px] mx-auto"
          />
          <img
            src={ExpressionPink}
            alt=""
            className="absolute w-[112px] bottom-[-15px] left-[-13px] z-0"
          />
          <img
            src={ExpressionGreen}
            alt=""
            className="absolute w-[91px] bottom-[-45px] right-0 rotate-[-4.139deg] z-0"
          />
        </aside>
        <div className="w-full bg-white py-[200px] px-[50px]">
          <h3 className="text-4xl font-nunito font-bold text-center mb-[50px]">
            Reset Password?
          </h3>
          <p className="w-[453px] text-[22px] text-center mx-auto mb-[50px]">
            Enter your email to start reset your password
          </p>
          <Formik
            initialValues= {initialValues}
            validationSchema= {forgotPasswordSchema}
            onSubmit={(values) => onHandleResetPassword(values)}
          >
            {({errors, values}) => {
              return (
              <Form>
                <div className="w-[453px] mx-auto grid justify-items-center">
                  <div className="col-span-2 flex justify-end items-center relative">
                    <Field
                      type="email"
                      name="email"
                      placeholder="Email Address"
                      className="rounded-[99px] w-[453px] h-[66px] box-border mb-[60px] pr-[55px] pl-8 py-[10px] bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color opacity-[0.99] placeholder:text-form-placeholder-color"
                    />
                    {!errors.email && values.email !== ""  && (
                      <img
                        src={ApproveIcon}
                        className="w-[36px] h-[36px] absolute mr-6 mt-[-58px] flex-shrink-0"
                        alt=""
                      />
                    )}
                  </div>
                  <div className="w-[453px] justify-start mt-[-55px]">
                    {errors.email && <small className="text-red-500">{errors.email}</small>}
                  </div>

                  <div
                    className=" col-span-2 w-[451px] h-[76px] rounded-[99px] py-[26px] mb-[55px] leading-[21px] bg-custom-navy text-white text-base font-bold text-center cursor-pointer"
                  >
                    <button type="submit" className="w-[451px]">Reset</button>
                  </div>
                </div>
              </Form>
            )}}
            </Formik>
        </div>
      </div>
      {loading && <Loader/>}
    </Fragment>  
  );
}

export default ForgotPassword;
